// extracted by mini-css-extract-plugin
export default {"root":"MainLayout_root__XWpE1","body":"MainLayout_body__9b6OC","main":"MainLayout_main__yGoKH","spinner":"MainLayout_spinner__mcfBk"};